const { nextTick } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const autoFocus = {
    mounted(el) {
        nextTick(() => el.querySelector('input').focus());
    },
};
exports.default = autoFocus;
